import { createContext } from 'react';

export const PermissionsContext = createContext({
  loading: true,
  permissions: new Set(),
  has: () => false,
});
